import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './device_error.routes';
import DeviceErrorService from '../../components/api/device_error/device_error.service';

export class DeviceErrorController {
    /*@ngInject*/
    constructor(DeviceErrorService, $interval) {
        this.cloud_discon_list    = [];
        this.meter_fault_list     = [];
        this.meter_not_found_list = [];
        this.demand_fault_list    = [];

        this.interval = $interval;

        this.DeviceErrorService = DeviceErrorService
    }

    $onInit() {
        this.update();

        this.timer = this.interval(() => {
            this.update();
        }, 20000);
    }

    update() {
        let cloud_discon_list    = [];
        let meter_fault_list     = [];
        let meter_not_found_list = [];
        let demand_fault_list    = [];

        this.DeviceErrorService.api.index(error_list => {
            for(let error of error_list){
                if(error.cloud_disconnected){ cloud_discon_list.push(error); }
                if(error.meter_not_found){ meter_not_found_list.push(error); }
                if(error.meter_off || error.meter_fault){ meter_fault_list.push(error); }
                if(error.demand_fault){ demand_fault_list.push(error); }
            }

            this.cloud_discon_list = cloud_discon_list;
            this.meter_not_found_list = meter_not_found_list;
            this.meter_fault_list = meter_fault_list;
            this.demand_fault_list = demand_fault_list;
        });
    }

    $onDestroy() {
        if(this.timer) {
            this.interval.cancel(this.timer);
        }
    }

    isReadingDevice(device) {
      return device.operating_mode === 'reading';
    }
}

export default angular.module('leptonApp.deviceError', [uiRouter, DeviceErrorService])
    .config(routing)
    .component('deviceError', {
        template: require('./device_error.html'),
        controller: DeviceErrorController
    })
    .name



// WEBPACK FOOTER //
// ./public/dev/app/device_error/device_error.component.js